import type { CommunityPost } from '~/interfaces/community';

export const countReactions = (reactionsCount: CommunityPost['reactions_count']) =>
  Object.values(reactionsCount).reduce((total, count) => total + (count ?? 0), 0);
